import FormatService from '../../../../services/format-service';
import FormService from '../../../../services/form-service';

const PasswordRecoveryValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const passwordRecoveryFormRequiredFields: string[] = [
    'password',
    'passwordConfirm',
  ];

  passwordRecoveryFormRequiredFields.forEach((field: string): void => {
    if ((!values[field] || !values[field].toString().trim()) && values[field] !== null) {
      errors[field] = 'Required';
    }
  });

  if (values.password && !FormatService.isValidPassword(values.password)) {
    errors.password = `Password must contain ${FormService.PASSWORD_FIELD_LENGTH_MIN} characters, at least one `
      + 'letter in lower case, one letter in upper case and one number or one symbol';
  }

  if (values.password && values.passwordConfirm && values.password !== values.passwordConfirm) {
    errors.passwordConfirm = 'Password confirmation does not match';
  }

  return errors;
};

export default PasswordRecoveryValidator;
